import styled from 'styled-components';
import { Box, Button } from '@mui/material';

export const ContainerSearch = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 40px;

  @media (max-width: 805px) {
    gap: 1rem;
  }
`;

export const BoxSearch = styled.form`
  display: flex;
  max-width: 100%;
  max-height: 42px;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const InputBox = styled.div`
  flex: 1;
  width: 100%;
  height: 42px;
  display: flex;
  background: #fff;
  padding: 5px;
`;

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: 0 1rem;
  font-size: 16px;
  height: 100%;

  @media (max-width: 382px) {
    padding: 0px;
    font-size: 14px;
  }
`;

export const SearchIconButton = styled.button`
  background: none;
  height: 100%;
  border-left: 1px solid #ccc;
  border-bottom: none;
  border-top: none;
  border-right: none;
  border-radius: 0;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;

  img {
    width: 24px;
  }
`;

export const ButtonDelete = styled(Button)`
  padding: 3px 6px;
  min-width: 30px;
  background: red;
  color: #fff;

  &:hover {
    background-color: red;
  }
`;

export const ButtonDetails = styled(Button)`
  padding: 3px 6px;
  min-width: 30px;
  background: #6e3296;

  &:hover {
    background-color: #6e3296;
  }
`;
